<template>
	<div class="thirdView">
		<div class="dec mainCont"  v-html="content"></div>
		<div class="box mainCont" v-if="false">
			<div class="left" >
				<ul>
					<li>
						<img src="../../../../static//about/qitem4-img2.png" alt="">
						<div class="txt">
							<span class="label">联系电话</span>
							<p>16541564545</p>
						</div>
					</li>
					<li>
						<img src="../../../../static//about/qitem4-img1.png" alt="">
						<div class="txt">
							<span class="label">公司地址</span>
							<p>郑州市金水区中央商务区格拉姆大厦508</p>
						</div>
					</li>
				</ul>

			</div>
			<div class="right"><img src="../../../../static//map.png" alt=""></div>
		</div>
			
	</div>
</template>

<script>
	import {getArtice} from '@/api/api'
	import {formatRichText} from "@/utils/utils"
	export default {
		name: 'secondView',
		components: {},
		data() {
			return {
				articeObj:{},
				content:'',
			};
		},
		mounted() {
			this.getArtice();
		},
		methods: {
			// 企业简介
			getArtice(){
				getArtice({type:'7'}).then(res => {
					this.articeObj = res.data;
					
					this.formatRichText(res.data.content)
				})
			},
			
			// 处理富文本里的图片宽度自适应
			formatRichText(html) {
			    if(!html){
			        return ''
			    }
			    let newContent = html.replace(/<img[^>]*>/gi, function(match, capture) {
			        match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
			        match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
			        match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
			        return match;
			    });
			    newContent = newContent.replace(/style="[^"]+"/gi, function(match, capture) {
			        match = match.replace(/width:[^;]+;/gi, 'width:100%;').replace(/width:[^;]+;/gi, 'width:100%;');
			        return match;
			    });
			    newContent = newContent.replace(/<br[^>]*\/>/gi, '');
			    newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:10px 0;"');
			    this.content = newContent;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.thirdView {padding-top: 56px;padding-bottom: 150px;
		.dec{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
			p{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;padding: 0;}
			img{width: 100% !important;margin-bottom: 10px;display: block;}
		}
		.box{display: flex;align-items: center;background: #2F78FF;
			.left{width: 50%;
				ul{padding-left: 64px;padding-top:64px;
					li{display: flex;align-items: center;margin-bottom: 40px;
						img{width: 56px;}
						.txt{margin-left: 30px;color: #fff;
							.label{color: 14px;}
							p{font-size: 18px;margin-top: 14px;}
						}
					}
				}
			}
			.right{width: 50%;background-color: #EFF3FB;
				img{width: 100%;}
			}
		}
		
	}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/components/thirdView.vue